import { segmentEventTrack, segmentPageTrack } from "@/shared/segment";
import { useEffect } from "react";

const MODULE_NAME = "setup";
const BUSINESS_UNIT_NAME = "platform";

export const setEventTracking = (
  name: string,
  params?: Record<string, string>
) => {
  segmentEventTrack({
    name,
    params,
    module: MODULE_NAME,
    businessUnit: BUSINESS_UNIT_NAME,
  });
};

export const setPageTracking = (
  name: string,
  params?: Record<string, string>
) => {
  segmentPageTrack({
    name,
    params,
    module: MODULE_NAME,
    businessUnit: BUSINESS_UNIT_NAME,
  });
};

export const usePageTracking = (
  name: string,
  params?: Record<string, string>
) => {
  useEffect(() => {
    segmentPageTrack({
      name,
      params,
      module: MODULE_NAME,
      businessUnit: BUSINESS_UNIT_NAME,
    });
  }, []);
};
